import { Grid } from "@mui/material";
import { Input, Space } from "antd";
import { useWorkflowContainerFullStore } from "../../../store";
import {
  AddonBefore,
  DividerComponent,
  ScanComponent,
} from "../../../../../libs/shared";
import { useScan } from "../../../../../libs/hooks";

export const SecondComponent = ({ widthFull }: { widthFull: string }) => {
  return (
    <Grid
      container
      spacing={2}
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      sx={{
        minHeight: `calc(100vh - 105px)`,
        maxHeight: `calc(100vh - 105px)`,
        height: `calc(100vh - 105px)`,
        overflowY: "auto",
        overflowX: "hidden",
        position: "relative",
        pt: 6,
        pb: 2,
        width: "100%",
      }}
    >
      <SellosSalidaVerificadoraComponent width={widthFull} />
      <SellosSalidaExportadorComponent width={widthFull} />
      <SellosNavieraComponent width={widthFull} />
      <DocumentosComponent width={widthFull} />
    </Grid>
  );
};

//SELLOS SALIDA VERIFICADORA
const SellosSalidaVerificadoraComponent = ({ width }: { width: string }) => {
  return (
    <>
      <DividerComponent label="SELLOS SALIDA VERIFICADORA" />
      <EtiquetaPuertaComponent width={width} />
      <SelloCableComponent width={width} />
      <BotellaVerificadoraRastreoComponent width={width} />
      <NumRastreoComponent width={width} />
    </>
  );
};

const EtiquetaPuertaComponent = ({ width }: { width: string }) => {
  const adhesivo = useWorkflowContainerFullStore((state) => state.adhesivo);
  const setAdhesivo = useWorkflowContainerFullStore(
    (state) => state.setAdhesivo
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setAdhesivo(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="ETIQUETA PUERTA" width={width} />}
            value={adhesivo || ""}
            onChange={(e) => setAdhesivo(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const SelloCableComponent = ({ width }: { width: string }) => {
  const cableVerificadora = useWorkflowContainerFullStore(
    (state) => state.cableVerificadora
  );
  const setCableVerificadora = useWorkflowContainerFullStore(
    (state) => state.setCableVerificadora
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setCableVerificadora(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="SELLO CABLE" width={width} />}
            value={cableVerificadora || ""}
            onChange={(e) => setCableVerificadora(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const BotellaVerificadoraRastreoComponent = ({ width }: { width: string }) => {
  const botellaVerificadoraRastreo = useWorkflowContainerFullStore(
    (state) => state.botellaVerificadoraRastreo
  );
  const setBotellaVerificadoraRastreo = useWorkflowContainerFullStore(
    (state) => state.setBotellaVerificadoraRastreo
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setBotellaVerificadoraRastreo(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="SELLO RASTREO" width={width} />}
            value={botellaVerificadoraRastreo || ""}
            onChange={(e) => setBotellaVerificadoraRastreo(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const NumRastreoComponent = ({ width }: { width: string }) => {
  const numRastreoSatelital = useWorkflowContainerFullStore(
    (state) => state.numRastreoSatelital
  );
  const setNumRastreoSatelital = useWorkflowContainerFullStore(
    (state) => state.setNumRastreoSatelital
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setNumRastreoSatelital(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="N° RASTREO" width={width} />}
            value={numRastreoSatelital || ""}
            onChange={(e) => setNumRastreoSatelital(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

//SELLOS SALIDA VERIFICADORA
const SellosSalidaExportadorComponent = ({ width }: { width: string }) => {
  return (
    <>
      <DividerComponent label="SELLOS SALIDA EXPORTADORA" />
      <NumeroKitComponent width={width} />
      <TermografoComponent width={width} />
      <EtiquetPuertaExportadorComponent width={width} />
      <EtiquetaBisagraComponent width={width} />
      <SelloCableExportadorComponent width={width} />
      <SelloBotellaExportadorComponent width={width} />
    </>
  );
};

const NumeroKitComponent = ({ width }: { width: string }) => {
  const numKit = useWorkflowContainerFullStore((state) => state.numKit);
  const setNumKit = useWorkflowContainerFullStore((state) => state.setNumKit);

  return (
    <>
      <Grid item xs={12}>
        <Input
          addonBefore={<AddonBefore label="N° KIT" width={width} />}
          value={numKit || ""}
          onChange={(e) => setNumKit(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
      </Grid>
    </>
  );
};

const TermografoComponent = ({ width }: { width: string }) => {
  const termografo = useWorkflowContainerFullStore((state) => state.termografo);
  const setTermografo = useWorkflowContainerFullStore(
    (state) => state.setTermografo
  );

  return (
    <>
      <Grid item xs={12}>
        <Input
          addonBefore={<AddonBefore label="TERMOGRAFO" width={width} />}
          value={termografo || ""}
          onChange={(e) => setTermografo(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
      </Grid>
    </>
  );
};

const EtiquetPuertaExportadorComponent = ({ width }: { width: string }) => {
  const adhesivoPuerta = useWorkflowContainerFullStore(
    (state) => state.adhesivoPuerta
  );
  const setAdhesivoPuerta = useWorkflowContainerFullStore(
    (state) => state.setAdhesivoPuerta
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setAdhesivoPuerta(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="ETIQUETA PUERTA" width={width} />}
            value={adhesivoPuerta || ""}
            onChange={(e) => setAdhesivoPuerta(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const EtiquetaBisagraComponent = ({ width }: { width: string }) => {
  const setAdhesivoBisagra = useWorkflowContainerFullStore(
    (state) => state.setAdhesivoBisagra
  );
  const adhesivoBisagra = useWorkflowContainerFullStore(
    (state) => state.adhesivoBisagra
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setAdhesivoBisagra(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="ETIQUETA BISAGRA" width={width} />}
            value={adhesivoBisagra || ""}
            onChange={(e) => setAdhesivoBisagra(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const SelloCableExportadorComponent = ({ width }: { width: string }) => {
  const cableExpor = useWorkflowContainerFullStore((state) => state.cableExpor);
  const setCableExpor = useWorkflowContainerFullStore(
    (state) => state.setCableExpor
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setCableExpor(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="SELLO CABLE" width={width} />}
            value={cableExpor || ""}
            onChange={(e) => setCableExpor(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const SelloBotellaExportadorComponent = ({ width }: { width: string }) => {
  const botellaExpor = useWorkflowContainerFullStore(
    (state) => state.botellaExpor
  );
  const setBotellaExpor = useWorkflowContainerFullStore(
    (state) => state.setBotellaExpor
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setBotellaExpor(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="SELLO BOTELLA" width={width} />}
            value={botellaExpor || ""}
            onChange={(e) => setBotellaExpor(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

//SELLOS NAVIERA
const SellosNavieraComponent = ({ width }: { width: string }) => {
  return (
    <>
      <DividerComponent label="SELLOS NAVIERA" />
      <SelloNavieraBotellaComponent width={width} />
    </>
  );
};

const SelloNavieraBotellaComponent = ({ width }: { width: string }) => {
  const botellaNaviera = useWorkflowContainerFullStore(
    (state) => state.botellaNaviera
  );
  const setBotellaNaviera = useWorkflowContainerFullStore(
    (state) => state.setBotellaNaviera
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setBotellaNaviera(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="SELLO BOTELLA" width={width} />}
            value={botellaNaviera || ""}
            onChange={(e) => setBotellaNaviera(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

//DOCUMENTOS
const DocumentosComponent = ({ width }: { width: string }) => {
  return (
    <>
      <DividerComponent label="DOCUMENTOS" />
      <TarjaCargaComponent width={width} />
      <EvaluacionFrutaComponent width={width} />
      <GuiaDeTransporteComponent width={width} />
    </>
  );
};

const TarjaCargaComponent = ({ width }: { width: string }) => {
  const tarjaCarga = useWorkflowContainerFullStore((state) => state.tarjaCarga);
  const setTarjaCarga = useWorkflowContainerFullStore(
    (state) => state.setTarjaCarga
  );

  return (
    <>
      <Grid item xs={12}>
        <Input
          addonBefore={<AddonBefore label="TARJA DE CARGA" width={width} />}
          value={tarjaCarga || ""}
          onChange={(e) => setTarjaCarga(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
      </Grid>
    </>
  );
};

const EvaluacionFrutaComponent = ({ width }: { width: string }) => {
  const evaluacionFruta = useWorkflowContainerFullStore(
    (state) => state.evaluacionFruta
  );
  const setEvaluacionFruta = useWorkflowContainerFullStore(
    (state) => state.setEvaluacionFruta
  );

  return (
    <>
      <Grid item xs={12}>
        <Input
          addonBefore={
            <AddonBefore label="EVALUACIÓN DE FRUTA" width={width} />
          }
          value={evaluacionFruta || ""}
          onChange={(e) => setEvaluacionFruta(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
      </Grid>
    </>
  );
};

const GuiaDeTransporteComponent = ({ width }: { width: string }) => {
  const guiaTransporte = useWorkflowContainerFullStore(
    (state) => state.guiaTransporte
  );
  const setGuiaTransporte = useWorkflowContainerFullStore(
    (state) => state.setGuiaTransporte
  );

  return (
    <>
      <Grid item xs={12}>
        <Input
          addonBefore={<AddonBefore label="GUÍA DE TRANSPORTE" width={width} />}
          value={guiaTransporte || ""}
          onChange={(e) => setGuiaTransporte(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
      </Grid>
    </>
  );
};
